import axios from "axios";
import { Base_URL } from "../url";

/**
 * CREATE DepartmentOrg (Dept + Org mapping)
 */
export const createDepartmentOrg = async (data) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userId = userDetails?.userId;

    const response = await axios.post(
      `${Base_URL}/DepartmentOrgMaster/Create?UserName=${userId}`,
      data
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || "Error creating department-org mapping!";
  }
};

/**
 * GET Departments by OrgId
 */
export const getDepartmentsByOrgId = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/DepartmentOrgMaster/GetByOrgId/${orgId}`
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching departments by org!";
  }
};

/**
 * GET DepartmentOrg records by DeptCode
 */
export const getDepartmentOrgByDeptCode = async (deptCode) => {
  try {
    const response = await axios.get(
      `${Base_URL}/DepartmentOrgMaster/GetByDeptCode/${deptCode}`
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching department-org data!";
  }
};

/**
 * GET Single DepartmentOrg (OrgId + DeptCode)
 */
export const getDepartmentOrgByOrgAndDept = async (payload) => {
  try {
    const response = await axios.post(
      `${Base_URL}/DepartmentOrgMaster/GetByOrgAndDept`,
      payload
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching department-org record!";
  }
};
